import React from 'react';
import classNames from 'classnames';

const CalculatedGroup = (props) => {
  const {
    renderAllQuestions,
    className
  } = props;

  const classes = classNames(
    className,
    'questionGroup--calculatedGroup',
    'calculatedGroup'
  );

  return (
    <section className={ classes }>
      { renderAllQuestions() }
    </section>
  );
};

export default CalculatedGroup;
